import { FunctionOverrides } from "@/__configs/config_types";
import { useConfigValue } from "./useConfigValue";

const useFunctionOverride = <T>(orig: T, name: keyof FunctionOverrides) => {
  const func: T | undefined = useConfigValue(["functionOverrides", name]);

  if (func) {
    return func;
  }

  return orig;
};

export default useFunctionOverride;